require('angular')
require('angular-route')
require('../../core/translation/translation-module')
require('../components/auth/auth-module')
require('../components/account/account-module')
require('../components/common-wrapper/common-wrapper-module')
require('../components/error-handler/error-handler-module')
require('../components/form/form-module.coffee')
# Load Template
require('./new.jade')
require('./edit.jade')
# Load Css
require('../../../sass/web/html/_email_confirmation.scss')

EmailConfirmationNewCtrl = require('./new-controller')
EmailConfirmationEditCtrl = require('./edit-controller')
EmailConfirmationService = require('./email-confirmation-service')
RegistrationService = require('./../registration/registration-service')

modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-auth'
  'gnp-common-wrapper'
  'gnp-form'
  'gnp-error-handler'
  'gnp-account'
  'gnp-animate'
]
angular.module 'gnp-app-email-confirmation', modules
  .config ['$routeProvider', ($routeProvider) ->
    $routeProvider.when '/email_confirmation/new',
      templateUrl: 'web/email-confirmation/new.jade'
      controller: 'EmailConfirmationNewCtrl'
      title: '_CONFIRMATION.NEW.TITLE'
      resolve:
          account: ['RegistrationService', (RegistrationService) ->
            RegistrationService.get()
          ]
      permission:
        signInRequired: true
    .when '/email_confirmation/edit/:token',
      templateUrl: 'web/email-confirmation/edit.jade'
      controller: 'EmailConfirmationEditCtrl'
      title: '_CONFIRMATION.EDIT.TITLE'
      permission:
        signInRequired: true
      resolve:
        userInfo: ['AuthService', 'AccountService', (AuthService, AccountService) ->
          AccountService.getUserInfo() if AuthService.isSignedIn()
        ]
  ]
  .config ['$translateProvider', ($translateProvider) ->
    $translateProvider
    .translations 'en', require('./i18n/en')
    .translations 'ja', require('./i18n/ja')
  ]
  .controller 'EmailConfirmationNewCtrl', EmailConfirmationNewCtrl
  .controller 'EmailConfirmationEditCtrl', EmailConfirmationEditCtrl
  .factory 'EmailConfirmationService', EmailConfirmationService
  .factory 'RegistrationService', RegistrationService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/email-confirmation/email-confirmation-module.coffee